import { render, staticRenderFns } from "./PersonalDetailPopUp.vue?vue&type=template&id=1bef2126&"
import script from "./PersonalDetailPopUp.vue?vue&type=script&lang=ts&"
export * from "./PersonalDetailPopUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PersonalDetailPopUp.vue"
export default component.exports